import { render, staticRenderFns } from "./SearchModalOffers.vue?vue&type=template&id=c65a6be4&scoped=true"
import script from "./SearchModalOffers.vue?vue&type=script&lang=js"
export * from "./SearchModalOffers.vue?vue&type=script&lang=js"
import style0 from "./SearchModalOffers.vue?vue&type=style&index=0&id=c65a6be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65a6be4",
  null
  
)

export default component.exports